<template>
    <BjDialog :title="$t('SelectSKUText')" :visible="visible" width="600px" @close="visible = false">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="8" :get-action="queryApi"
      :selection="selection" :right-toolbar-hide="true"
      @handleSelectionChange="handleSelectionChange2" @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan * 2">
            <el-form-item label="" prop="skuCode">
                <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" placeholder="SKU" clearable />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="{ row }">
                <span>{{ row[col.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- <el-table ref="table" border :data="SKU_LIST" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="standardSkuCode" align="center" :label="$t('BjDialogListConfig.SKUcode')"></el-table-column>
        <el-table-column prop="skuName" align="center" :label="$t('BusinessPurchaseOrder2.form.skuName')"></el-table-column>
      </el-table> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onAddDialogConfirm">{{ $t('okText') }}</el-button>
      </span>
    </BjDialog>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';

export default {
  mixins: [pageMiXin],
  data() {
    return {
      visible: false,
      queryApi: purchaseApi.getPurchaseOrderListGoods,
      labelList: [
        { label: this.$t('BjDialogListConfig.SKUcode'), prop: 'standardSkuCode', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.form.skuName'), prop: 'skuName', isCheck: true, disabled: false},
      ],
      queryParams: {
        id: this.$route.query.id,
        skuCode: null
      },
      selection: [],
    };
  },
  methods: {
    handleSelectionChange2(row) {
        this.selection = row.selection;
    },
    onAddDialogConfirm() {
        this.$emit('submit', this.selection);
    }
  }
};
</script>
